<app-shared-dialog
  [title]="((canSubmit$ | async) === true ? (((!isUpdate ? 'common.new' : 'common.update') | translate) + ' ') : '') + ('inventory.category' | translate)"
  [options]="{
    size: 'medium',
    confirmText: (!isUpdate ? 'common.create' : 'common.update') | translate,
    cancelText: 'common.cancel' | translate,
    confirmButtonStyle: 'primary',
    confirmIcon: 'arrow-right',
    confirmIconPosition: 'end',
    customConfirmButton: true
  }"
  (cancel)="closed()">

  <form class="add-categories__form" [formGroup]="form">

    <!-- ── Image drop zone (Knowledge-style) ─────────────────────────── -->
    <div
      class="drop-zone"
      *appHasPermission="submitPermission()"
      [class.has-file]="uploadedImage || displayedImage"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="fileInput.click()">
      <input
        type="file"
        #fileInput
        (change)="onFileChange($event)"
        accept="image/jpeg, image/png, image/gif"
        hidden>
      <ng-container *ngIf="!uploadedImage && !displayedImage">
        <ui-svg-icon svgIcon="upload" size="large" class="drop-zone__icon"></ui-svg-icon>
        <span class="drop-zone__text">{{ 'Categories.drag_and_drop_category_photo' | translate }}</span>
        <span class="drop-zone__hint">JPG, PNG, GIF</span>
      </ng-container>
      <ng-container *ngIf="uploadedImage || displayedImage">
        <div class="drop-zone__file">
          <img class="drop-zone__preview"
            [src]="uploadedImage ? 'data:;base64,' + uploadedImage : getImage()"
            alt="">
          <ui-button
            type="transparent"
            icon="close"
            iconSize="small"
            (click)="cancelImage(); $event.stopPropagation()">
          </ui-button>
        </div>
      </ng-container>
    </div>

    <!-- ── Code ────────────────────────────────────────────────────────── -->
    <div class="form-field">
      <label class="form-field__label">{{ 'common.code' | translate }}</label>
      <ui-form-field
        type="text"
        formControlName="code"
        [placeholder]="'common.code' | translate"
        [errorMessages]="{ required: ('validation.required' | translate) }">
      </ui-form-field>
    </div>

    <!-- ── Name ────────────────────────────────────────────────────────── -->
    <div class="form-field">
      <label class="form-field__label">{{ 'Categories.category_name' | translate }}</label>
      <ui-form-field
        type="text"
        formControlName="name"
        [placeholder]="'common.name' | translate"
        [errorMessages]="{ required: ('validation.required' | translate) }">
      </ui-form-field>
    </div>

    <!-- ── Parent category ─────────────────────────────────────────────── -->
    <div class="form-field">
      <label class="form-field__label">{{ 'Categories.Parent_category' | translate }}</label>
      <ui-form-field
        type="select"
        formControlName="parent_id"
        [options]="parentCategoryOptions"
        [placeholder]="'common.select' | translate">
      </ui-form-field>
    </div>

    <!-- ── Description ─────────────────────────────────────────────────── -->
    <div class="form-field">
      <label class="form-field__label">{{ 'common.description' | translate }}</label>
      <ui-form-field
        type="textarea"
        formControlName="description"
        [placeholder]="'common.description' | translate">
      </ui-form-field>
    </div>

    <!-- ── Status ──────────────────────────────────────────────────────── -->
    <div class="form-field">
      <label class="form-field__label">{{ 'common.status' | translate }}</label>
      <ui-form-field
        type="select"
        formControlName="status"
        [options]="statusOptions"
        [placeholder]="'common.select' | translate">
      </ui-form-field>
    </div>
  </form>
  <ui-button
    customConfirm
    *appHasPermission="submitPermission()"
    type="primary"
    [label]="(!isUpdate ? 'common.create' : 'common.update') | translate"
    icon="arrow-right"
    iconPosition="end"
    (click)="save()">
  </ui-button>
</app-shared-dialog>
